<template>
    <section id="projects" class="grid-section">
        <div class="content">
            <transition appear name="slide-left">
                <div class="transition-wrapper" v-show="showProjectMenu">
                    <h2 class="section-head">{{ sectionHeadlineProjects }}</h2>
                    <nav>
                        <ul id="projects-menu">
                            <li>
                                <router-link @mouseover.native="showPreview = 1" @mouseout.native="showPreview = null"
                                             to="/Bizziice">Bizziice
                                </router-link>
                            </li>
                            <li>
                                <router-link @mouseover.native="showPreview = 2" @mouseout.native="showPreview = null"
                                             to="/Stuttgart-Airport-City">Stuttgart Airport City
                                </router-link>
                            </li>
                            <li>
                                <router-link @mouseover.native="showPreview = 3" @mouseout.native="showPreview = null"
                                             to="/MJS-Air-Klima">MJS Air Klima
                                </router-link>
                            </li>
                            <li>
                                <router-link @mouseover.native="showPreview = 4" @mouseout.native="showPreview = null"
                                             to="/Stray">Stråy
                                </router-link>
                            </li>
                            <li>
                                <router-link @mouseover.native="showPreview = 5" @mouseout.native="showPreview = null"
                                             to="/Gerch-Group">Gerch Group
                                </router-link>
                            </li>
                            <li>
                                <router-link @mouseover.native="showPreview = 6" @mouseout.native="showPreview = null"
                                             to="/Millemedia">Millemedia
                                </router-link>
                            </li>
                            <li>
                                <router-link @mouseover.native="showPreview = 7" @mouseout.native="showPreview = null"
                                             to="/Posters">Posters
                                </router-link>
                            </li>

                        </ul>
                    </nav>
                </div>
            </transition>
        </div>
        <transition appear name="pop">
            <div v-show="showPreview === 1" class="preview" id="prev-1"></div>
        </transition>
        <transition appear name="pop">
            <div v-show="showPreview === 2" class="preview" id="prev-2"></div>
        </transition>
        <transition appear name="pop">
            <div v-show="showPreview === 3" class="preview" id="prev-3"></div>
        </transition>
        <transition appear name="pop">
            <div v-show="showPreview === 4" class="preview" id="prev-4"></div>
        </transition>
        <transition appear name="pop">
            <div v-show="showPreview === 5" class="preview" id="prev-5"></div>
        </transition>
        <transition appear name="pop">
            <div v-show="showPreview === 6" class="preview" id="prev-6"></div>
        </transition>
        <transition appear name="pop">
            <div v-show="showPreview === 7" class="preview" id="prev-7"></div>
        </transition>

    </section>
</template>

<script>
    export default {
        name: "Projects",
        props: {
            sectionHeadlineProjects: String,
            showProjectMenu: Boolean,
        },
        data() {
            return {
                showPreview: null
            }
        }
    };
</script>

<style scoped>

    #projects-menu {
        font-weight: 700;
        font-size: 2.5rem;
    }

    #projects-menu li::before {
        content: url("../assets/svg/arrow.svg");
        position: absolute;
        margin-top: 0.2rem;
        margin-left: -16%;
        opacity: 0;
        transition: margin-left .5s, opacity .5s cubic-bezier(0.075, 0.82, 0.165, 1);
    }

    #projects-menu li:hover::before {
        margin-left: -6%;
        opacity: 1;
    }

    .preview {

        grid-column: 4 / 6;
        grid-row: 2 / 6;
        border-radius: 50%;
        width: 100%;
        height: 33.2vw;
        background-origin: border-box;
        background-size: cover;
    }


    #prev-1 {
        background-image: url("../assets/img/bizzi/prev_bizzi.jpg");
    }

    #prev-2 {
        background-image: url("../assets/img/sac/prev_sac.jpg");
    }

    #prev-3 {
        background-image: url("../assets/img/airklima/prev_airklima.jpg");
    }

    #prev-4 {
        background-image: url("../assets/img/stray/prev_stray.jpg");
    }

    #prev-5 {
        background-image: url("../assets/img/gerch/prev_gerch.jpg");
    }

    #prev-6 {
        background-image: url("../assets/img/mille/prev_mille.jpg");
    }

    #prev-7 {
        background-image: url("../assets/img/posters/prev_posters.jpg");
    }

    /*** SCREENS ***/

    /* Mobile: Portrait and Landscape */
    @media only screen
    and (min-device-width: 320px)
    and (max-device-width: 600px)
    and (-webkit-min-device-pixel-ratio: 2) {

      #projects-menu {
        font-size: 2rem;
        line-height: 3.5rem;
      }
    }

</style>
